import { createContext, useContext } from 'react';

import { type TLocale, Locales } from 'src/lib/constants';

const LocaleContext = createContext<TLocale>(Locales.EN_US);

export const usePageLocale = () => {
  const locale = useContext(LocaleContext);
  return locale;
};

export default LocaleContext;
